import { useEffect, useState } from 'react';

/**
 * Subscribe to a CSS media query. Returns false during SSR / before the
 * first effect runs.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/** Tailwind's md breakpoint. */
export function useIsMobile(): boolean {
  return !useMediaQuery('(min-width: 768px)');
}
